module.exports = __webpack_public_path__ + "no-installed.png?02e8a5a88fb86ff92a826b621a5f5447";